import { formatAmount } from "../helper/utils";
import { useSelector } from "react-redux";

export const useFormattedAmount = () => {
  const { precision, round } = useSelector(state => state.misc.settings);

  const getFormattedAmount = (
    amount,
    precisionOverride = null,
    roundOverride = null,
    intl = true,
  ) => {
    // Return null if amount is null
    if (amount === null) return null;

    // Use provided precision and round or fall back to defaults from the store
    const effectivePrecision = precisionOverride !== null ? precisionOverride : precision;
    const effectiveRound = roundOverride !== null ? roundOverride : round;

    const amt = formatAmount(amount, effectivePrecision, effectiveRound);

    if (!intl) {
      return amt;
    }

    // Format the number with commas
    return new Intl.NumberFormat("en-US", { minimumFractionDigits: effectivePrecision }).format(
      amt,
    );
  };

  return getFormattedAmount;
};
